import { gameImageUrl, handleImageFallback } from '../../lib/utils';

const HOT_GAME_ORDER = [
  { code: 'juwa', name: 'juwa' },
  { code: 'game_vault', name: 'game vault' },
  { code: 'firekirin', name: 'fire kirin' },
  { code: 'ultrapanda', name: 'ultra panda' },
];

const normalize = (value) => String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_');

export default function HotGamesSlider({ games, onGameClick }) {
  const allGames = games || [];
  const hotGames = HOT_GAME_ORDER
    .map((target) => allGames.find((game) => {
      const identifiers = [
        game.id,
        game.code,
        game.provider_code,
        game.name,
      ].map(normalize);
      return identifiers.includes(normalize(target.code)) || identifiers.includes(normalize(target.name));
    }))
    .filter(Boolean);

  return (
    <div className="grid grid-cols-4 gap-3 pb-2">
      {hotGames.map((game) => (
        <div key={game.id} onClick={() => onGameClick(game.id)} className="cursor-pointer min-w-0 group"
          data-testid={`hot-game-${game.id}`}>
          <div className="aspect-square rounded-xl overflow-hidden mb-2 border border-white/10 group-hover:border-[#D4AF37]/70 transition-all"
            style={{ boxShadow: '0 8px 18px rgba(0,0,0,0.34), 0 0 12px rgba(212,175,55,0.08)' }}>
            <img src={gameImageUrl(game)} alt={game.name}
              loading="lazy" decoding="async"
              referrerPolicy="no-referrer"
              onError={handleImageFallback}
              className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-300" />
          </div>
          <p className="text-[11px] sm:text-xs font-semibold text-center truncate text-gray-300 group-hover:text-white">{game.name}</p>
        </div>
      ))}
    </div>
  );
}
